import { _ as _freeGlobal } from "./auth-service-tools1011.js";
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var _root = root;
export { _root as _ };